import owd from 'owd/owd';
import 'lib/fixed-header-table';

export default class FixedHeader extends owd.Component {
	init() {
		this.bind();
        //console.log($.fn.fixedHeaderTable);
	}

	bind() {
        this.on('load ajaxload', this.dom.$window, (e) => {
            //console.log(this.$element.find('table'));
            this.$element.find('table').fixedHeaderTable({height: '500px'});
            //this.app.dom.$window.trigger('imageload', e.target);
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('fixed-header', {
	component: FixedHeader
});
